import React from 'react';

import { useFilterState } from '../shared/FinancialDataContext/FinancialDataContext';
import { QueriesPanel } from './QueriesPanel/QueriesPanel';
import SearchList from './SearchList';

interface OwnProps {
  benchmarkRefinement: boolean;
}

const CompaniesPageSearchPanel: React.FC<OwnProps> = ({ benchmarkRefinement }) => {
  const { appliedFilters, requestFiltersData } = useFilterState();
  const isSearchListVisible = appliedFilters.length && Object.keys(requestFiltersData).length;

  return isSearchListVisible ? (
    <SearchList benchmarkRefinement={benchmarkRefinement} />
  ) : (
    <QueriesPanel />
  );
};

export default CompaniesPageSearchPanel;
